import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {RATING_RANGE} from '../../constants';
import {CustomSelect} from '../StyledComp';

const SelectRating = ({t, onChange, value, allowNull, ...props}) => {
  const ratings = [];

  for (let i = RATING_RANGE.START; i < RATING_RANGE.END + 1; i++) {
    ratings.push(<option value={i} key={i}>{t('ratingStar', {count: i})}</option>);
  }

  return (
    <CustomSelect
      name="rating"
      onChange={onChange}
      value={value}
      absolute
      {...props}>
      <option disabled value="default">
        {t('rating')}
      </option>
      {allowNull && <option value={0}>{t('all')}</option>}
      {ratings}
    </CustomSelect>
  );
};

SelectRating.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  allowNull: PropTypes.bool,
};

SelectRating.defaultProps = {
  allowNull: false,
};

export default withTranslation('merchant')(SelectRating);
